// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1Mto3","colMin":"styles_colMin__1NtW4","colCheckbox":"styles_colCheckbox__ICk1Z"};